import type {
  ActivitiesConfigVersionFormat,
  InsuranceProduct,
  InsuranceProductVersion,
  ProductVersionFormat,
} from '../../model/model.ts'

import type { FrPrelPolicyItems, FrPrelPolicyItemsState } from './fr-prel-insurance.ts'
import type { FrPrelPricingVersion } from './fr-prel-pricing-versions.ts'
import { frPrelPolicyItemsV1_0_0 } from './v1_0_0/policy-items.ts'
import { frPrel_V1_0_0_StaticFilesIds } from './v1_0_0/static-files.ts'

export const frPrelProductName = 'product-fr-pre-lourmel'
export type FrPrelProductName = typeof frPrelProductName

type FrPrelProductVersionFormat = ProductVersionFormat<'fr-pre-lourmel'>
export type FrPrelActivitiesConfigVersionFormat = ActivitiesConfigVersionFormat<FrPrelProductName>

export const frPrelProductVersions = [
  /**
   * Initial version
   */
  'product-fr-pre-lourmel-1.0.0-2026-03-20',
] as const satisfies FrPrelProductVersionFormat[]

export type FrPrelProductVersion = (typeof frPrelProductVersions)[number]

export const allFrPrelStaticFilesIds = [...frPrel_V1_0_0_StaticFilesIds] as const

export type FrPrelStaticFilesId = (typeof allFrPrelStaticFilesIds)[number]

export const allFrPrelStaticFilesReferences = {
  'fr-prel-v1_0_0-general-terms': 'Conditions generales - Prévoyance Individuelle Professionnelle',
  'fr-prel-v1_0_0-ipid': 'Fiche IPID',
} as const satisfies Record<FrPrelStaticFilesId, string>

export const frPrelStaticFilesNameByStaticFileId = {
  'fr-prel-v1_0_0-general-terms': 'Conditions generales - Prevoyance Individuelle Professionnelle',
  'fr-prel-v1_0_0-ipid': 'Fiche IPID',
} as const satisfies Record<FrPrelStaticFilesId, string>

export const frPrelStaticFilesIdsByProductVersion = {
  'product-fr-pre-lourmel-1.0.0-2026-03-20': frPrel_V1_0_0_StaticFilesIds,
} as const satisfies Record<FrPrelProductVersion, readonly FrPrelStaticFilesId[]>

export const frPrelRiskCarrierProductTypeNames = ['fr-prel-inde-v1'] as const

export type FrPrelRiskCarrierProductType = (typeof frPrelRiskCarrierProductTypeNames)[number]

export const frPrelProduct_V_1_0_0 = {
  version: 'product-fr-pre-lourmel-1.0.0-2026-03-20',
  description: 'Version initiale du produit FR PREL',
  policyItems: frPrelPolicyItemsV1_0_0,
  staticFilesId: [...frPrel_V1_0_0_StaticFilesIds],
  pricingVersion: ['pricing-fr-pre-lourmel-1.0.0-2026-03-20'],
  activitiesConfigVersion: 'activities-config-product-fr-pre-lourmel-1.0.0-2026-03-20',
} as const satisfies InsuranceProductVersion<
  FrPrelProductName,
  FrPrelProductName,
  FrPrelProductVersion,
  FrPrelPolicyItems,
  FrPrelStaticFilesId,
  FrPrelPricingVersion,
  FrPrelActivitiesConfigVersionFormat,
  FrPrelPolicyItemsState
>

export const frPrelProduct = {
  id: 'fr-prel',
  versions: {
    'product-fr-pre-lourmel-1.0.0-2026-03-20': frPrelProduct_V_1_0_0,
  },
} as const satisfies InsuranceProduct<
  FrPrelProductName,
  FrPrelProductName,
  FrPrelProductVersion,
  FrPrelPolicyItems,
  FrPrelStaticFilesId,
  FrPrelPricingVersion,
  FrPrelActivitiesConfigVersionFormat,
  FrPrelPolicyItemsState
>

export type FrPrelProduct = typeof frPrelProduct
